import Pc from '@/pages/Pc'
import NewGallery from '@/pages/fundingnew/my/gallery/list'
import NewGalleryDetail from '@/pages/fundingnew/my/gallery/detail'
import NewProfile from '@/pages/fundingnew/my/Profile'
import NewSubmissions from '@/pages/fundingnew/my/Submissions'
import fundingIndx from '@/pages/fundingnew/index/index'
import jolindetail from '@/pages/fundingnew/project/jolin'

import NewCalendar from '@/pages/fundingnew/calendar/Calendar'
import NewExplore from '@/pages/fundingnew/Explore'
import NewMoreTips from '@/pages/fundingnew/MoreTips'

import NewCreation from '@/pages/fundingnew/creation/Creation'
import NewCreationStep1 from '@/pages/fundingnew/creation/Step1'
import NewCreationStep2 from '@/pages/fundingnew/creation/Step2'
import NewCreationStep3 from '@/pages/fundingnew/creation/Step3'
import NewCreationPreview from '@/pages/fundingnew/creation/Preview'
import NewProjectDetail from '@/pages/fundingnew/project/Detail'
import Ticket from '@/pages/fundingnew/ticket'

const gallery = [
  {
    path: '/fundingnew/calendar',
    name: 'NewCalendar',
    component: NewCalendar,
    meta: {
      title: '活动日历',
      auth: false,
    },
  },
  {
    path: '/fundingnew/explore',
    name: 'NewExplore',
    component: NewExplore,
    meta: {
      title: '绝对夜计划',
      auth: false,
    },
  },
  {
    path: '/fundingnew/more_tips',
    name: 'NewMoreTips',
    component: NewMoreTips,
    meta: {
      title: '评判与贴士',
      auth: false,
    },
  },
  {
    path: '/fundingnew/creation',
    name: 'NewCreation',
    component: NewCreation,
    meta: {
      title: '说明页',
      auth: false,
    },
  },
  {
    path: '/fundingnew/creation/step1',
    name: 'NewCreationStep1',
    component: NewCreationStep1,
    meta: {
      title: '造一个',
      auth: true,
      jicePageTitle: '百城创造页面',
    },
  },
  {
    path: '/fundingnew/creation/step2',
    name: 'NewCreationStep2',
    component: NewCreationStep2,
    meta: {
      title: '造一个',
      auth: true,
      jicePageTitle: '百城创造页面',
    },
  },
  {
    path: '/fundingnew/creation/step3',
    name: 'NewCreationStep3',
    component: NewCreationStep3,
    meta: {
      title: '造一个',
      keepAlive: true,
      auth: true,
      jicePageTitle: '百城创造页面',
    },
  },
  {
    path: '/fundingnew/creation/preview',
    name: 'NewCreationPreview',
    component: NewCreationPreview,
    meta: {
      title: '造一个',
      auth: true,
    },
  },
  {
    path: '/fundingnew/project/:id',
    name: 'NewProjectDetail',
    component: NewProjectDetail,
    meta: {
      title: '详情',
      auth: false,
    },
  },
  {
    path: '/pc',
    name: 'pc',
    component: Pc,
    meta: {
      title: '首页',
      auth: false,
    },
  },
  {
    path: '/fundingnew/my/gallery/list',
    name: 'NewGallery',
    component: NewGallery,
    meta: {
      title: '夜计划现场',
      auth: true,
    },
  },
  {
    path: '/fundingnew/my/gallery/detail/:id',
    name: 'NewGalleryDetail',
    component: NewGalleryDetail,
    meta: {
      title: '夜计划现场',
      auth: true,
    },
  },
  {
    path: '/fundingnew/my/submissions',
    name: 'NewSubmissions',
    component: NewSubmissions,
    meta: {
      title: '我的信息',
      auth: true,
      jicePageTitle: '个人中心页',
    },
  },
  {
    path: '/fundingnew/my/profile',
    name: 'NewProfile',
    component: NewProfile,
    meta: {
      title: '我的信息',
      auth: true,
    },
  },
  // funding
  {
    path: '/fundingnew/index',
    name: 'fundingIndex',
    component: fundingIndx,
    meta: {
      title: '绝对赛博',
      auth: false,
      jicePageTitle: '悬赏夜计划（100 campaign）',
    },
  },
  {
    path: '/fundingnew/jolindetail',
    name: 'jolindetail',
    component: jolindetail,
    meta: {
      title: '绝对夜计划',
      auth: false,
    },
  },
  {
    path: '/fundingnew/ticket',
    name: 'ticket',
    component: Ticket,
    meta: {
      title: '绝对夜计划',
      auth: false,
    },
  },
]

export default gallery



// WEBPACK FOOTER //
// ./src/router/fundingnew.js